import React, { useEffect, useState, memo } from 'react'

export interface INoticeItemProps {
  content: React.ReactNode;
  id?: string;
  duration?: number;
  className?: string;
  mask?: boolean;
  onClose?: (id?: string) => void;
}

const NoticeItem: React.FC<INoticeItemProps> = (props) => {
  const { id, content, duration = 2000, onClose } = props
  const [active, setActive] = useState('')

  const handleClose = (id?: string) => {
    setActive('')
    setTimeout(() => {
      onClose && onClose(id)
    }, 400)
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setActive('active')
    }, 200)
    return () => {
      timer && clearTimeout(timer)
    }
  }, [])

  useEffect(() => {
    let timer: NodeJS.Timeout
    if (duration !== 0) {
      timer = setTimeout(() => {
        handleClose(id)
      }, duration)
    }
    return () => {
      timer && clearTimeout(timer)
    }
  }, [duration, id, onClose])

  return <div className={`notice-item ${active} ${props.className || ''}`}>{content}</div>
}

export default memo(NoticeItem)
